import styled from 'styled-components';

export const AaPlatformStyled = styled.div`
  .input_row {
    margin-bottom: 0.75rem;
    display: flex;
    column-gap: 1rem;
    .input_wrap {
      flex: 1;
    }
  }

  .btn_zone {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .w120 {
      width: 120px;
    }
  }
`;
